import React, {useEffect, useState} from 'react';
import { renderDropdown, renderDropdownReadOnly} from "../../gdpr/ui/DropdownFunctions";
import SpinnerDiv from "../../gdpr/ui/SpinnerDiv";
import PropTypes from "prop-types";
import {getSchoolGroups} from "../../gdpr/ui/DropdownDataProviders";

const DropdownSchoolGroups = (props ) =>
{
    const [ data, setData ] = useState ( { loading: true, items : [] } ) ;

    useEffect(() => {
        getSchoolGroups(props.school_id).then (rows =>
        {
            //Add the All option to the top of dropdown
            const all = {label: 'All', value: 0}
            rows.unshift(all);
            setData ( { loading: false, items: rows }) ;
        })
    }, []);

    const options = {
        isSearchable: true,
        isClearable: props.isClearable === null || props.isClearable === undefined ? true : props.isClearable,
    }

    return data.loading === true ? <SpinnerDiv/> :
    (
        props.readOnly === 'readonly' ? renderDropdownReadOnly(props, data) : renderDropdown(props, data, options)
    )
}

export default DropdownSchoolGroups;

DropdownSchoolGroups.defaultProps =
{
    defaultClassName: 'form-group'
}

DropdownSchoolGroups.propTypes = {
    onChange: PropTypes.func.isRequired
};